<template>
  <v-dialog v-if="bookingForm.booking.state == 'completed'" v-model="receiptDialog" width="800px">
    <template v-slot:activator="{ on }">
      <v-btn small class="text-none" v-on="on">Send Receipt</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Send Receipt</span>
      </v-card-title>
      <v-layout column px-4>
        <v-text-field v-model="email" label="Email Recipient"></v-text-field>
        <p style="color:red;" v-if="receiptError != null">{{ receiptError }}</p>
      </v-layout>
      <v-card-actions v-if="loadingSendReceipt == false">
        <v-spacer></v-spacer>
        <v-btn flat text @click="receiptDialog = false">Cancel</v-btn>
        <v-btn flat text @click="sendReceipt()">Send Receipt</v-btn>
      </v-card-actions>
      <v-progress-linear v-if="loadingSendReceipt == true" indeterminate color="yellow darken-2"></v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "SendReceipt",
  mounted: function() {
    this.email = this.bookingForm.user.email;
  },
  components: {},
  props: {
    bookingForm: Object
  },
  data: function() {
    return {
      receiptDialog: false,
      loadingSendReceipt: false,
      receiptEmail: null,
      receiptError: null,
      email: null
    };
  },
  methods: {
    sendReceipt: async function() {
      console.log("Sending Receipt");

      this.receiptError = null;

      if (this.email == null || this.email.length <= 0) {
        this.receiptError =
          "Please enter an email address for the receipt's recipient";
        return;
      }

      this.loadingSendReceipt = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/sendReceipt?booking_id=${this.bookingForm.booking.id}&user_id=${this.bookingForm.user.id}&email=${this.email}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendReceipt = false;

        if (response.data.error == "no_error") {
          this.receiptDialog = false;
        } else {
          this.receiptError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.receiptError = "Unknown Error";

        this.loadingSendReceipt = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}
</style>

   
